const { textBoxStrLength } = require("../config/config");

var CryptoJS = require("crypto-js");

process.env.TZ = "Asia/Calcutta";

const customName = (fullname) => {
  if (!fullname || typeof fullname !== "string" || !fullname.trim()) {
    return "";
  }

  const nameArray = fullname.trimStart().split(" ");

  let result;

  if (nameArray.length > 1) {
    result =
      nameArray[0].charAt(0).toUpperCase() +
      nameArray[nameArray.length - 1].charAt(0).toUpperCase();
  } else {
    result = nameArray[0].charAt(0).toUpperCase();
  }

  return result;
};

const formatDateTimeFormat = (date) => {
  const sourceDate = new Date(date).toDateString();
  const sourceTime = new Date(date).toLocaleTimeString();
  // The above yields e.g. 'Mon Jan 06 2020'

  const [, month, day, year] = sourceDate.split(" ");
  const formattedDate = [day, month, year].join(" ");
  //

  let [hour, minute, second] = sourceTime.split(" ")[0].split(":");
  if (hour.length === 1) {
    hour = "0" + hour;
  }
  const formattedTime =
    [hour, minute].join(":") + " " + sourceTime.split(" ")[1];
  return {
    formattedTime,
    formattedDate,
  };
};

const formatTimeFormat = (time) => {
  const timeArray = time.split(":");

  let session = "AM";
  let hour = timeArray[0];
  let minute = timeArray[1];
  if (hour >= 12) {
    session = "PM";
    if (hour != 12) {
      if (hour - 12 < 10) {
        hour = `0${hour - 12}`;
      } else {
        hour = `${hour - 12}`;
      }
    }
  }
  let finalTime = `${hour}:${minute}`;
  const result = `${finalTime} ${session}`;
  return result;
};
const getTimeSession = (time) => {
  const timeArray = time.split(":");
  const timeHour = timeArray[0];

  if (timeHour > 12) {
    return "PM";
  }
  return "AM";
};

const checkRsvpCount = (attendees) => {
  let yesCount = 0;
  let noCount = 0;
  let pendingCount = 0;
  let mayBeCount = 0;

  attendees.map((item) => {
    item.rsvp === "YES"
      ? (yesCount = yesCount + 1)
      : item.rsvp === "NO"
        ? (noCount = noCount + 1)
        : item.rsvp === "MAYBE"
          ? (mayBeCount = mayBeCount + 1)
          : (pendingCount = pendingCount + 1);
  });

  const countMessage = `${yesCount} Yes, ${noCount} No, ${mayBeCount} May Be, ${pendingCount} Awaiting`;

  return {
    yesCount,
    noCount,
    mayBeCount,
    pendingCount,
    countMessage,
  };
};

const convertFirstLetterToCapital = (text) => {
  if (text) {
    return (
      text?.trimStart().charAt(0).toUpperCase() + text.toLowerCase().slice(1)
    );
  } else {
    return "";
  }
};

const convertFirstLetterOfFullNameToCapital = (textData) => {
  const textArray = textData?.split(" ");

  const convertedTextArray = textArray?.map((text) => {
    return (
      text.trimStart().charAt(0).toUpperCase() + text.toLowerCase().slice(1)
    );
  });
  return convertedTextArray.join(" ");
};

const checkCharacterLeft = (string) => {
  return textBoxStrLength - string.length;
};

//The Function Below To Encrypt Text
const encryptWithAES = (text) => {
  const passphrase = process.env.REACT_APP_PASSWORD_KEY;
  return "ENC::" + CryptoJS.AES.encrypt(text, passphrase).toString();
};

const combineDateAndTime = (date1, time) => {
  const date = new Date(date1);

  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);

  const modifiedHour =
    time.split(":")[0] < 10
      ? time.split(":")[0].split("")[1]
      : time.split(":")[0];
  const modifiedMinute =
    time.split(":")[1] < 10
      ? time.split(":")[1].split("")[1]
      : time.split(":")[1];
  date.setHours(date.getHours() + parseInt(modifiedHour));
  date.setMinutes(date.getMinutes() + parseInt(modifiedMinute));

  return date;
};

const convertTimetoIST = (time) => {
  const timeArray = time.split(":");
  const timeHour = timeArray[0];
  if (timeHour >= 12 && timeHour !== 24) {
    let finalHour = timeHour == 12 ? 12 : timeHour - 12;
    finalHour = finalHour.toString().length == 1 ? "0" + finalHour : finalHour;
    return finalHour + ":" + timeArray[1] + " PM";
  } else if (timeHour == 24) {
    return "00" + ":" + timeArray[1] + " AM";
  } else {
    return timeHour + ":" + timeArray[1] + " AM";
  }
};

const getDaysDiiference = (fromDate, toDate) => {
  let date1 = new Date(fromDate.toString());
  let date2 = new Date(toDate.toString());
  // Convert dates to UTC timestamps
  let utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
  let utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
  // Calculate the time difference in milliseconds
  let timeDiff = utc2 - utc1;
  // Convert milliseconds to days
  let daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

  return daysDiff;
};

const fetchIpAddress = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("Error fetching IP address:", error);
  }
};

const getStringLengthAfterHTMLParse = (htmlString) => {
  // Create a temporary element to parse the HTML
  const tempElement = document.createElement("div");
  tempElement.innerHTML = htmlString;

  // Extract the plain text content
  const plainText = tempElement.textContent || tempElement.innerText || "";

  // Return the length of the text
  return plainText.length;
};

const sliceTextFromHTML = (htmlString, start, end) => {
  // Create a temporary element to parse the HTML
  const tempElement = document.createElement("div");
  tempElement.innerHTML = htmlString;

  // Extract the plain text content
  const plainText = tempElement.textContent || tempElement.innerText || "";

  // Slice the text
  return plainText.slice(start, end);
};
function sliceHtmlEncodedString(encodedStr, length) {
  // Step 1: Create a temporary DOM element to decode the HTML string
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = encodedStr;
  const decodedStr = tempDiv.textContent || tempDiv.innerText;

  // Step 2: Slice the plain text to the desired length
  const slicedText = decodedStr.slice(0, length);

  // Step 3: Encode the sliced text back to an HTML-encoded string
  tempDiv.textContent = slicedText;
  return tempDiv.innerHTML;
}
const convertIsoFormat = (date) => {
  const utcDate = new Date(date);
  const utcOffset = 5.5 * 60 * 60 * 1000; // IST is UTC+5:30
  const istDate = new Date(utcDate.getTime() + utcOffset);
  return istDate.toISOString();
};

const checkEmptyString = (emptyHtml2) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(emptyHtml2, "text/html");

  // Extract the text content
  const parsedContent = doc.body.textContent.trim();

  // If the content is empty or only contains empty tags, return null
  if (parsedContent === "" || parsedContent === "<br>") {
    return null;
  }

  return parsedContent || ""; // Return parsed content or empty string if there's no meaningful content
};

const cleanInput = (str) => {
  return str
    .replace(/[\u2013\u2014\u2012\u2212]/g, "-") // En, em, figure, minus dashes → hyphen
    .replace(/[\u2018\u2019]/g, "'") // Curly single quotes → straight
    .replace(/[\u201C\u201D]/g, '"') // Curly double quotes → straight
    .replace(/\u2026/g, "...") // Ellipsis → 3 dots
    .replace(/\u00B7/g, ".") // Middle dot → dot
    .replace(/[\u202F\u00A0]/g, " ") // Narrow/Non-breaking space → normal space
    .replace(/\s+/g, " ") // Collapse multiple spaces
    .trim(); // Trim whitespace
};
const parseDate = async (inputDate) => {
  // Convert inputDate to a valid Date object (assuming format is DD-MM-YYYY)
  const dateParts = inputDate.split("-"); // Split by the dash
  const jsDate = new Date(
    Date.UTC(dateParts[2], dateParts[1] - 1, dateParts[0])
  ); // Date.UTC(year, monthIndex, day)

  // Now, format to "YYYY-MM-DDTHH:mm:ss.SSS[Z]"
  const formattedDate = jsDate.toISOString(); // This gives "2025-04-16T00:00:00.000Z"

  return formattedDate;
};

const idColorMap = {};
const idOrder = [];

const predefinedColors = [
  "#E53935", // red
  "#1E88E5", // blue
  "#FB8C00", // orange
  "#43A047", // green
  "#8E24AA", // purple
  "#3949AB", // indigo
  "#F4511E", // deep orange
  "#00ACC1", // cyan
  "#7CB342", // light green
  "#D81B60", // pink-red
  "#5E35B1", // deep purple
  "#039BE5", // sky blue
  "#EF6C00", // orange-red
  "#00897B", // teal
  "#C0CA33", // lime
  "#6D4C41", // brown
  "#00838F", // dark cyan
  "#9E9D24", // mustard
  "#3949AB", // blue variant
  "#C62828", // red variant
  "#1565C0", // strong blue
  "#FFB300", // amber
  "#2E7D32", // strong green
  "#AB47BC", // lavender
  "#1A237E", // navy
  "#F44336", // red
  "#64B5F6", // light blue
  "#FFA726", // light orange
  "#81C784", // light green
  "#D32F2F", // red
  "#1976D2", // blue
  "#FF7043", // coral
  "#66BB6A", // medium green
  "#BA68C8", // orchid
  "#3F51B5", // blue
  "#E91E63", // pink-red
  "#2196F3", // standard blue
  "#FF9800", // orange
  "#4CAF50", // classic green
  "#9C27B0", // purple
  "#3F51B5", // blue
  "#F44336", // red
  "#03A9F4", // blue
  "#FF5722", // orange
  "#8BC34A", // lime green
  "#673AB7", // violet
  "#00BCD4", // cyan
  "#CDDC39", // yellow-green
];

const getColorFromId = (id) => {
  if (!id) return "#888";
  if (idColorMap[id]) return idColorMap[id];

  if (!idOrder.includes(id)) {
    idOrder.push(id);
  }

  const index = idOrder.indexOf(id);
  const color = predefinedColors[index % predefinedColors.length];
  idColorMap[id] = color;
  return color;
};

const predefinedColorsGuest = [
  "#4CAF50",
  "#9C27B0",
  "#3F51B5", // blue
  "#F44336", // red
  "#03A9F4", // blue
  "#FF5722", // orange
  "#8BC34A", // lime green
  "#673AB7", // violet
  "#00BCD4", // cyan
  "#CDDC39", // yellow-green
  "#E53935", // red
  "#1E88E5", // blue
  "#FB8C00", // orange
  "#43A047", // green
  "#8E24AA", // purple
  "#3949AB", // indigo
  "#F4511E", // deep orange
  "#00ACC1", // cyan
  "#7CB342", // light green
  "#D81B60", // pink-red
  "#5E35B1", // deep purple
  "#039BE5", // sky blue
  "#EF6C00", // orange-red
  "#00897B", // teal
  "#C0CA33", // lime
  "#6D4C41", // brown
  "#00838F", // dark cyan
  "#9E9D24", // mustard
  "#3949AB", // blue variant
  "#C62828", // red variant
  "#1565C0", // strong blue
  "#FFB300", // amber
  "#2E7D32", // strong green
  "#AB47BC", // lavender
  "#1A237E", // navy
  "#F44336", // red
  "#64B5F6", // light blue
];

const emailColorMap = {};
const emailOrder = [];

const getColorFromEmail = (email) => {
  if (!email) return "#888";
  if (emailColorMap[email]) return emailColorMap[email];

  if (!emailOrder.includes(email)) {
    emailOrder.push(email);
  }

  const index = emailOrder.indexOf(email);
  const color = predefinedColorsGuest[index % predefinedColorsGuest.length];
  emailColorMap[email] = color;
  return color;
};

const convertDateToUTC = (date) => {
  let date1 = new Date(date);

  // Convert dates to UTC timestamps
  let utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());

  return utc1;
};

//The Function Below To Decrypt Text
const decryptWithAES = (ciphertext) => {
  if (ciphertext?.startsWith("ENC::")) {
    const passphrase = process.env.REACT_APP_PASSWORD_KEY;
    const bytes = CryptoJS.AES.decrypt(ciphertext?.slice(5), passphrase);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText;
  } else {
    return ciphertext;
  }
};

const formatDate = (dateString) => {
  if (!dateString) return "Not Available";

  const date = new Date(dateString);

  if (isNaN(date.getTime())) return "Invalid Date";

  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "long" });
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};

const getOrCreateDeviceId = () => {
  let deviceId = localStorage.getItem("deviceId");

  if (!deviceId) {
    deviceId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
    localStorage.setItem("deviceId", deviceId);
  }

  return deviceId;
};

const onlyTime = (date) => {
  console.log(date);
  const options = {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  };

  return new Intl.DateTimeFormat("en-IN", options).format(new Date(date));
};

const addMinutesInHours = (time, addTime) => {
  //   const actualFromTime = props.meetingData?.actualFromTime; // "19:00"
  // const agendaTime = 16; // in minutes
  console.log(time);
  // Split the time into hours and minutes
  const [hours, minutes] = time.split(":").map(Number);

  // Create a Date object with today's date and the given time
  const now = new Date();
  const startTime = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    hours,
    minutes
  );

  // Add agendaTime minutes
  const endTime = new Date(startTime.getTime() + addTime * 60 * 1000);

  // Format back to HH:mm
  const result = endTime.toTimeString().slice(0, 5);

  console.log(result); // e.g., "19:16"
  return result;
};

const currentTime = () => {
  const now = new Date();
  let hours = now.getHours();
  const minutes = now.getMinutes().toString().padStart(2, "0");

  // Convert to 12-hour format
  hours = hours % 12 || 12; // converts 0 to 12
  const formattedHours = hours.toString().padStart(2, "0");

  const timeFormatted = `${formattedHours}:${minutes}`;
  console.log(timeFormatted); // e.g., "12:12"
  return timeFormatted;
};

const getRoundedTime = (interval = 30) => {
  const now = new Date();
  now.setSeconds(0);
  now.setMilliseconds(0);

  const minutes = now.getMinutes();
  const roundedMinutes = Math.ceil(minutes / interval) * interval;

  if (roundedMinutes === 60) {
    now.setHours(now.getHours() + 1);
    now.setMinutes(0);
  } else {
    now.setMinutes(roundedMinutes);
  }

  return now.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false, // <== 24-hour format
  });
};
const parseAndDecryptHTML = (htmlString) => {
  // Match all <strong>...</strong> tags
  const strongTagRegex = /<strong>(.*?)<\/strong>/gi;

  const updatedHTML = htmlString.replace(strongTagRegex, (match, content) => {
    const ciphertext = content.trim();
    console.log("trimmedContent->", ciphertext);

    // const ciphertext = trimmedContent.replace(/^Enc::/, "").trim();
    console.log("encrypted", ciphertext);
    if (ciphertext?.startsWith("ENC::")) {
      const passphrase = process.env.REACT_APP_PASSWORD_KEY;
      const bytes = CryptoJS.AES.decrypt(ciphertext?.slice(5), passphrase);
      const originalText = bytes.toString(CryptoJS.enc.Utf8);
      console.log("originalText->", originalText);
      return originalText;
    } else {
      return ciphertext;
    }

    return match;
  });
  console.log("updatedHTML->", updatedHTML);
  return updatedHTML;
};

module.exports = {
  customName,
  formatDateTimeFormat,
  getTimeSession,
  checkRsvpCount,
  convertFirstLetterToCapital,
  convertFirstLetterOfFullNameToCapital,
  checkCharacterLeft,
  encryptWithAES,
  combineDateAndTime,
  convertTimetoIST,
  getDaysDiiference,
  fetchIpAddress,
  formatTimeFormat,
  decryptWithAES,
  getStringLengthAfterHTMLParse,
  sliceTextFromHTML,
  sliceHtmlEncodedString,
  convertIsoFormat,
  checkEmptyString,
  cleanInput,
  parseDate,
  getColorFromId,
  convertDateToUTC,
  formatDate,
  getColorFromEmail,
  getOrCreateDeviceId,
  onlyTime,
  addMinutesInHours,
  currentTime,
  getRoundedTime,
  parseAndDecryptHTML,
};
